import {Drawer, ScrollArea} from '@mantine/core';
import React, {useEffect, useState} from 'react';

import logo from 'shared/assets/images/logo.png';
import darkLogo from 'shared/assets/images/logo-dark.png';

import {navigationConfig} from 'config/navigation';
import {useLocation} from 'react-router-dom';
import DrawerOption from './components/drawer-option';

import {
  Body,
  Card,
  Container,
  Content,
  LogoBox,
  Navigation,
  SideBar,
} from './styles';

import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import NavigationFooter from './components/navigation-footer';
import CityHeader from './components/city-header';
import CompanyHeader from './components/company-header';
import styled, {useTheme} from 'styled-components';
import {IoArrowBack} from 'react-icons/io5';
import {RiMenu2Line} from 'react-icons/ri';
import HoverButton from 'shared/components/hover-button';

interface Props {
  children?: React.ReactNode;
  hideDrawer?: boolean;
  floating?: boolean;
  wrapper?: boolean;
}

const DashboardLayout: React.FC<Props> = ({
  children,
  hideDrawer = false,
  floating = false,
  wrapper = true,
}) => {
  const [showDrawer, setShowDrawer] = useState(false);

  const {pathname} = useLocation();
  const {accessControl} = useAccessControls();
  const {colors} = useTheme();
  const theme = localStorage.getItem('theme');

  useEffect(() => {
    setShowDrawer(false);
  }, [pathname]);

  const getNavigation = () => (
    <Navigation>
      <LogoBox>
        <img
          src={theme === 'dark' ? darkLogo : logo}
          style={{
            width: 90,
            height: 60,
            marginLeft: -10,
          }}
        />
      </LogoBox>
      <ScrollArea style={{paddingRight: 15, width: '100%', paddingTop: 30}}>
        {accessControl?.companyId && <CompanyHeader />}
        {accessControl?.cityId && <CityHeader />}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            marginTop: 20,
          }}>
          {navigationConfig
            .filter((route) => !route.hidden)
            .map((route, index) => (
              <DrawerOption {...route} key={index} />
            ))}
        </div>
      </ScrollArea>
    </Navigation>
  );

  return (
    <>
      <Container {...{hideDrawer, floating}}>
        {!hideDrawer && (
          <SideBar>
            {getNavigation()}
            <NavigationFooter />
          </SideBar>
        )}
        <Body {...{hideDrawer, floating}}>
          {hideDrawer && (
            <Header>
              <img
                src={theme === 'dark' ? darkLogo : logo}
                style={{
                  width: 70,
                  height: 46,
                  marginLeft: -10,
                }}
              />
              <HoverButton
                icon={<RiMenu2Line />}
                onClick={() => setShowDrawer(true)}
              />
            </Header>
          )}
          {wrapper && (
            <Content>
              <Card>{children}</Card>
            </Content>
          )}
          {!wrapper && <Card>{children}</Card>}
        </Body>
      </Container>
      <Drawer
        styles={{
          inner: {width: 300},
        }}
        opened={showDrawer}
        onClose={() => setShowDrawer(false)}
        withCloseButton={false}>
        {getNavigation()}
        <div style={{marginTop: -15}}>
          <NavigationFooter />
        </div>
      </Drawer>
    </>
  );
};

export default DashboardLayout;

const Header = styled.div`
  width: 100%;
  height: 70px;
  background-color: ${(props) => props.theme.colors.card};
  display: flex;
  gap: 15px;
  align-items: center;
  padding: 15px 25px;
  position: sticky;
  justify-content: space-between;
  top: 0;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
`;
